<h6 mat-dialog-title class="heading text-primary">{{ title }}</h6>
<div mat-dialog-content>
  @if (message) {
    <p class="text-gray">{{ message }}</p>
  }
</div>
<div mat-dialog-actions align="end">
  <button class="btn-md-outlined-error mx-2" matRipple tabindex="-1" [mat-dialog-close]="false">{{ cancelButton }}</button>
  <button class="btn-md-filled-primary" matRipple [mat-dialog-close]="true" cdkFocusInitial>{{ okButton }}</button>
</div>
